// extracted by mini-css-extract-plugin
export default {"projectsSection":"Projects_projectsSection__zkFmT","projectsTitle":"Projects_projectsTitle__peLWl","grid":"Projects_grid__64TR3"};